<template>
  <div class="card shadow-sm border-0 mb-4 mt-3">
    <div class="card-body">
      <div class="p-2">
        <vue-good-table
          styleClass="vgt-table no-border"
          :rows="rows"
          :columns="columns"
        >
          <template slot="table-row" scope="props">
            <!-- Name Column -->
            <template v-if="props.column.field === 'name'">
              {{ toPascalCase(props.row.name) }}
            </template>

            <!-- Action Column -->
            <template v-if="props.column.field === 'action'">
              <!-- EDIT -->
              <button class="btn-pencil" v-if="permissions.includes('document.write')" @click="$emit('edit', props.row)">
                <i class="fa fa-pencil fs-5"></i>
              </button>

              <button
                class="btn-trash mx-2"
                v-if="permissions.includes('document.delete')"
                @click="$emit('delete', props.row.id)"
              >
                <i class="fa fa-trash fs-5"></i>
              </button>

              <button
                class="btn-download"
                v-if="permissions.includes('document.download')"
                @click="$emit('download', props.row)"
              >
                <i class="fa fa-arrow-down"></i>
              </button>
            </template>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";

export default {
  name: "DocumentTable",
  components: { VueGoodTable },
  props: ["rows", "columns"],
  data: function () {
    return {
      permissions: window.localStorage.getItem("permissions"),
    };
  },
  methods: {
    toPascalCase(str) {
      if (!str) return '';
      return str
        .toLowerCase()
        .split(/[\s_-]+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  }
};
</script>

<style scoped>
.btn-download {
  color: blue;
  border: none;
  background: transparent;
}
</style>
